var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSmallGreyLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5455 3.5H4.27273C3.40475 3.5 2.57232 3.8448 1.95856 4.45856C1.3448 5.07232 1 5.90475 1 6.77273V17.6818C1 18.5498 1.3448 19.3822 1.95856 19.996C2.57232 20.6097 3.40475 20.9545 4.27273 20.9545H19.5455C20.4134 20.9545 21.2459 20.6097 21.8596 19.996C22.4734 19.3822 22.8182 18.5498 22.8182 17.6818V6.77273C22.8182 5.90475 22.4734 5.07232 21.8596 4.45856C21.2459 3.8448 20.4134 3.5 19.5455 3.5ZM19.0982 5.68182L12.6836 12.0964C12.5822 12.1986 12.4616 12.2798 12.3286 12.3352C12.1957 12.3905 12.0531 12.4191 11.9091 12.4191C11.7651 12.4191 11.6225 12.3905 11.4896 12.3352C11.3566 12.2798 11.236 12.1986 11.1345 12.0964L4.72 5.68182H19.0982ZM20.6364 17.6818C20.6364 17.9711 20.5214 18.2486 20.3168 18.4532C20.1123 18.6578 19.8348 18.7727 19.5455 18.7727H4.27273C3.9834 18.7727 3.70592 18.6578 3.50134 18.4532C3.29675 18.2486 3.18182 17.9711 3.18182 17.6818V7.22L9.59636 13.6345C10.21 14.2474 11.0418 14.5917 11.9091 14.5917C12.7764 14.5917 13.6082 14.2474 14.2218 13.6345L20.6364 7.22V17.6818Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallGreyLetter);
export default __webpack_public_path__ + "static/media/Icon-Small-Grey-Letter.5e573e6f335ce1d1c9a29e844730399f.svg";
export { ForwardRef as ReactComponent };